/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Configuration from './base/configuration';
import ConfigureComparision from './base/configure-comparison';


const NumberConfiguration = (props) => {
	return (
		<Configuration title='Configure summary chart'>
			<ConfigureComparision />
		</Configuration>
	);
};

export default NumberConfiguration;
